import FormContainer from './components/Form.container';

const Form = ({
  match,
  location,
  t,
  fetchMealSizes,
  classes,
  history,
  fetchMealType,
  openSweetToast,
}) => (
  <FormContainer
    match={match}
    location={location}
    t={t}
    fetchMealSizes={fetchMealSizes}
    classes={classes}
    history={history}
    fetchMealType={fetchMealType}
    openSweetToast={openSweetToast}
  />
);

export default Form;
